import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class ChatUserMessageComponent extends Component {
  @service currentUser;
}
